import { render } from "./OtifGeral.vue?vue&type=template&id=4c918f22"
import script from "./OtifGeral.vue?vue&type=script&lang=js"
export * from "./OtifGeral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__